
import { sound, Sound } from "@pixi/sound";
// import { Assets } from "pixi.js";
import { Assets } from "pixi.js";
import { Group, Tween } from "tweedle.js";
//import { PerformanceProfiler } from "../PerformanceProfiler";
import { GameIntroComponent } from "../components/gameIntro/GameIntroComponent";
import { ScarabWinsComponent } from "../components/jackpot/ScarabWinsComponent";
import { MeterComponent } from "../components/meter/MeterComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
import { currentBackgorundMusicVolume, isGameAlreadyLoaded, isMusicBtnOnGlobal, RespinIndex, setBackgorundMusic, setIsGameAlreadyLoaded, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { setVisibleSymbols } from "../config/reelConfig";
import { CasinoChannelHandler, casinoEventEmitter } from "../core/CasinoChannelHandler";
import { Manager } from "../core/Manager";
import { SoundManager } from "../core/SoundManager";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { reelSpinEmitter } from "../core/reels/ReelInit";
import { wait } from "../core/utils";
import { EventConstants } from "../gameClientEvents/EventConstants";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { GameEvents } from "../gameClientEvents/GameEvents";
import { SoundConstants } from "../gameClientEvents/SoundConstants";
import { spinData } from "../server/getServerResposesFun";
import { BaseScene } from "./BaseScene";
import { BigWin } from "./BigWin";
import { FreeGameScene } from "./FreeGameScene";

const tweenGroup: Group = new Group();
export class BaseGameScene extends BaseScene {
    override assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win", 'common'];
    override assets: string[] = ["game-screen", "intro-screen", "big-win"];
    private backgroundMusic: Sound | null = null;
    private boundShakeEffect: () => void;

    private freSpinTrigger: number = 0;
    private freSpinTriggerBaseWin: number = 0;

    private freeGameScene: FreeGameScene | null = null;

    private autoTriggerTimeout: ReturnType<typeof setTimeout>;

    private pointerDownHandlerBase: () => void;

    private lineToggleTimeout: ReturnType<typeof setTimeout>;
    private togglePlay: boolean = false;
    constructor() {
        super();
        setVisibleSymbols(3);
        this.setupEventListeners();
        this.boundShakeEffect = this.shakeEffect.bind(this);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);

        this.pointerDownHandlerBase = this.onPointerDown.bind(this);
        //PerformanceProfiler.increment('sceneCreated');
    }

    private setupEventListeners(): void {
        // casinoEventEmitter.on('roundEnded', this.handleRoundEnded.bind(this));
        casinoEventEmitter.on('roundStarted', this.handleRoundStarted.bind(this));
        casinoEventEmitter.on('betChanged', this.handleBetChanged.bind(this));
        GameEvents.emitter.on(EventConstants.GAME_INTRO_COMPLETE, this.onGameReady, this);
        GameEvents.emitter.on(EventConstants.GAME_TRANSITION_COMPLETE, this.onTransitionComplete, this);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);

    }

    private async handleFeature(): Promise<void> {
        return new Promise((resolve) => {
            if (spinData.respins[RespinIndex.value].type === "rip_activated") {
                console.log("rip activated");
                resolve();
            } else {
                resolve();
            }
        });
    }

    private async handleRoundStarted() {
        this.spinReel();
    }

    private handleBetChanged() {
        console.log('BaseGameScene - betChanged:');
        this.resetToggleTimeout();
        this.reels.resetWinsOnBetChange();
    }

    private onPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage pointerdown");
        Manager.banner.off('pointerdown', this.pointerDownHandlerBase);
        this.freeGameSceneChange();
    }

    private setupBGSound() {
        this.backgroundMusic = SoundManager.find(SoundConstants.BASE_MUSIC); // initialize with ambient sound
        setBackgorundMusic(this.backgroundMusic);

        if (this.backgroundMusic) {
            this.backgroundMusic.loop = true;
            this.backgroundMusic.volume = currentBackgorundMusicVolume;//currentBackgorundMusicVolume;
            // console.log("this.backgroundMusic.volume", this.backgroundMusic.volume);
            this.backgroundMusic.singleInstance = true;
            // this.backgroundMusic.speed = 0.5;
            this.backgroundMusic.play();

            this.backgroundMusic.muted = !isMusicBtnOnGlobal;

            const tween = new Tween(this.backgroundMusic, tweenGroup)
                .to({ volume: currentBackgorundMusicVolume }, 2000)
                .onComplete(() => {
                    tweenGroup.remove(tween);
                })
                .start();

        }
    }

    private callFreeGameSceneChangeAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            console.log("calling freeGameSceneChnage auto")
            clearTimeout(this.autoTriggerTimeout);
            Manager.banner.off('pointerdown', this.pointerDownHandlerBase);
            this.freeGameSceneChange();
        }, 10000); // 10 seconds
    }

    private resetToggleTimeout() {
        clearTimeout(this.lineToggleTimeout);
        this.lineToggleTimeout = undefined;
        this.togglePlay = false;
    }

    public shakeEffect = () => {
        let duration = 250;
        let intensity = 20;

        const original = { x: this.x, y: this.y };
        const offset = { x: 0, y: 0 };

        new Tween(offset)
            .to({ x: 0, y: 0 }, duration)
            .onUpdate(() => {
                this.x = original.x + (Math.random() - 0.5) * intensity;
                this.y = original.y + (Math.random() - 0.5) * intensity;
            })
            .onComplete(() => {
                this.x = original.x;
                this.y = original.y;
            })
            .start();
    }

    private async spinReel(): Promise<void> {

        // Cancel any previously scheduled lineToggle
        this.resetToggleTimeout();
        sound.play(SoundConstants.BUTTON_CLICK, { volume: 0.8 });

        if (this.reels) {

            const [freeGameTrigger, winAmount = 0, accumulatedWins = 0, isFeatureTrigger = false] = await this.reels.startPlay("BASE");
            console.log("in BaseGameScene freeGameTrigger winAmount RespinIndex.value", freeGameTrigger, winAmount, accumulatedWins, RespinIndex.value, isFeatureTrigger);
            if (isFeatureTrigger) {
                await this.handleFeature();
                RespinIndex.increase();
            }

            if (spinData.respins[0]?.featureData?.winFeatureName === GameConstants.FEATURE_TYPE_1) {
                await this.scarabWin();
            }

            if (freeGameTrigger > 0 && Manager.banner) {

                this.freSpinTrigger = freeGameTrigger;
                this.freSpinTriggerBaseWin = winAmount;

                await this.reels?.processWinFeatureSymbol();

                Manager.casinoChannelHandler.reportFeatureEnter();

                await Manager.banner.appearFreeGameIntroBanner(this.freSpinTrigger);

                console.log("appearFreeGameIntroBanner");

                if (willBannerAutoProceedGlobal) {
                    this.callFreeGameSceneChangeAuto();
                }

                //attach a listner now
                Manager.banner.on('pointerdown', this.pointerDownHandlerBase);

            }
            else if (winAmount === -1) {
                console.log("in Gamescene- Bet declined");
            }
            else {
                await this.bigWin?.bigWinFunction(winAmount);
                console.log("in basegame before bigwin");
                Manager.casinoChannelHandler.reportGameRoundCompleted();
                console.log("in basegame after bigwin");
                this.togglePlay = true;
            }

            if (freeGameTrigger === -2) { // max win reached
                Manager.casinoChannelHandler.reportMaxWin();
            }


            if (this.togglePlay && winAmount > 0) {
                this.lineToggleTimeout = setTimeout(() => {
                    this.reels.lineToggle(0); // for toggle respin index will always be 0
                }, 2000);
            }

            if (winAmount !== -1 && freeGameTrigger <= 0) {
                DisplayComponent.get(MeterComponent).resumeIdle();
            }

        }
    }

    private scarabWin() {
        return new Promise<void>(async (resolve) => {
            await DisplayComponent.get(ScarabWinsComponent).startWinFeature(0, resolve);
        });
    }

    private async freeGameSceneChange() {
        if (!Manager.banner) return;

        // Transition BEFORE leaving; switch scene on transition "change" + 200ms
        // Manager.banner.startTransition();
        const bannerOutPromise = Manager.banner.disappearBanner();

        await wait(200);

        this.freeGameScene = new FreeGameScene(this.freSpinTrigger, this.freSpinTriggerBaseWin);
        await Manager.changeScene(this.freeGameScene, false);

        await bannerOutPromise;
        DisplayComponent.get(MeterComponent).activate(null);
        await this.freeGameScene.beginFeaturePlay();
    }

    // private async onIntroComplete() {
    //     this.reelFrame.alpha = 1;
    //     this.backgroundImageCont.alpha = 1;
    //     this.backgroundSpine.alpha = 1;
    //     this.setupBGSound();
    //     CasinoChannelHandler.reportGameStarted();
    //     setIsGameAlreadyLoaded(true);
    //     DisplayComponent.get(MeterComponent).startIdle();
    //     // await wait(5000);
    //     // DisplayComponent.get(ReelFrameComponent).upgrade(8, null);
    //     // DisplayComponent.get(ReelComponent).getInstance().animateMask(8);
    // }

    public async constructorWithAssets(): Promise<void> {
        this.initBaseLayering('background', 'baseBackgroundSkel', 'baseBackgroundAtlas');
        DisplayComponent.register(new DisplayComponentFactory(ReelComponent));
        DisplayComponent.get(ReelComponent).init();
        this.reels = DisplayComponent.get(ReelComponent).getInstance();
        this.setupReelFrame("reelBackSkel", "reelBackAtlas", !isGameAlreadyLoaded);
        this.setupCommonUI();

        if (!isGameAlreadyLoaded) {
            this.addComponent(GameIntroComponent, this);
        } else {
            DisplayComponent.get(MeterComponent).startIdle();
        }

        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.addChild(this.bigWin);

        this.resize(Manager.screenwidth, Manager.screenHeight);
    }

    private async onTransitionComplete() {
        CasinoChannelHandler.reportGameStarted();
    }

    private async onGameReady() {

        this.reelFrame.alpha = 1;
        this.backgroundImageCont.alpha = 1;
        this.backgroundSpine.alpha = 1;
        this.setupBGSound();
        setIsGameAlreadyLoaded(true);

        DisplayComponent.get(MeterComponent).startIdle();
    }



    public override destroy() {
        casinoEventEmitter.removeAllListeners('roundStarted');
        casinoEventEmitter.removeAllListeners('betChanged');
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);

        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        GameEvents.emitter.off(EventConstants.GAME_INTRO_COMPLETE, this.onGameReady, this);
        GameEvents.emitter.off(EventConstants.GAME_TRANSITION_COMPLETE, this.onTransitionComplete, this);
        DisplayComponent.unregister(GameIntroComponent);
        // Assets.unload(['background', 'baseBackgroundSkel', 'baseBackgroundAtlas']);
        Assets.unload(['gameIntroSkel', 'gameIntroAtlas', 'baseBackgroundSkel', 'baseBackgroundAtlas']);
        super.destroy();
    }

    public override resize(screenWidth: number, screenHeight: number): void {
        super.resize(screenWidth, screenHeight);
        let orientationScale = (Manager.Orientation === "LANDSCAPE") ? 1 : 0.8;
        this.reels.scale.set(orientationScale);
    }
}
